import { Navigate } from 'react-router-dom'

import NotFound from 'modules/core/components/NotFound'
import { useNavigation } from 'modules/core/hooks/useNavigation'

import { usePerformanceV2ModuleContext } from 'modules/performance_v2/hooks/usePerformanceV2ModuleContext'
import { getModuleActiveFeatures } from 'modules/performance_v2/lib/getModuleFeatures'

const RedirectToRoutePage = () => {
  const { navigation } = useNavigation()
  const { featuresAvailability } = usePerformanceV2ModuleContext()
  const { index } = getModuleActiveFeatures(featuresAvailability, navigation)

  if (index) {
    return <Navigate replace to={index.path} />
  }

  return <NotFound />
}

export default RedirectToRoutePage
